export default {
  name: "Map",
  props: ["coordinates", "styles", "type", "height", "markers", "infoWindows", "zoom", "zoomControl", "perimeters"],
  computed: {
    options: function() {
      return {
        zoom: this.$props.zoom || 7,
        scrollWheel: false,
        zoomControl: this.$props.zoomControl || false,
        disableDefaultUI: true,
        scaleControl: false,
        rotateControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeId: this.$props.type || "terrain",
        styles: this.$props.styles || []
      };
    },
  },
  watch: {
    "$props.height": {
      handler: function() {
        document.getElementById("map").style.height = this.$props.height;
      }
    },
    "$props.infoWindows": {
      handler: function(val) {
        if (this._isMounted) {
          if (val) {
            setTimeout(() => {
              const infoToHide = val.filter(s => !s.canClose);
              const infoEl = Array.from(document.getElementsByClassName("gm-style-iw gm-style-iw-c"));

              infoToHide.map(s => {
                const target = infoEl.find(el => el.innerText.replace(" ", "").toLowerCase().includes(s.text.replace(" ", "").toLowerCase()));
                if (target) {
                  const button = Array.from(target.children).find(child => child.title.toLowerCase() === "close");
                  if (button) {
                    target.removeChild(button);
                  }
                }
              });
            }, 1000);
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    document.getElementById("map").style.height = this.$props.height;
    setTimeout(() => {
      if (this.$props.infoWindows) {
        const infoToHide = this.$props.infoWindows.filter(s => !s.canClose);
        const infoEl = Array.from(document.getElementsByClassName("gm-style-iw gm-style-iw-c"));
        infoToHide.map(s => {
          const target = infoEl.find(el => el.innerText.replace(" ", "").toLowerCase().includes(s.text.replace(" ", "").toLowerCase()));
          if (target) {
            const button = Array.from(target.children).find(child => child.title.toLowerCase() === "close");
            if (button) {
              target.removeChild(button);
            }
          }
        });
      }
    }, 1000);
  }
};
